import { FloatingFormItem } from '@/components/_common';
import CfopSelectField from '@/components/_common/CfopSelectField';
import { useUpdateInvoiceItemCfop } from '@/core/domain/invoice/invoiceItem/invoiceItem.hook';
import { InvoiceType } from '@/core/domain/invoice/invoices/invoices.enums';
import { useDefaultEmptyFieldError } from '@/hooks';
import { Form, Modal } from 'antd';
import { useHistory } from 'react-router-dom';

interface Props {
  cfopModalVisible: boolean;
  setCfopModalVisible: () => void;
  invoiceId: number;
  invoiceType?: InvoiceType;
}

export default function InvoiceUpdateCfopModal({
  cfopModalVisible,
  setCfopModalVisible,
  invoiceId,
  invoiceType,
}: Props) {
  const updateItemCfop = useUpdateInvoiceItemCfop();
  const defaultEmptyFieldError = useDefaultEmptyFieldError();
  const [form] = Form.useForm();
  const history = useHistory();

  const handleUpdadeCfop = async () => {
    const { cfopId } = await form.validateFields();

    await updateItemCfop.mutateAsync({ invoiceId, cfopId });
    history.push(`/app/fiscal/invoice/${invoiceType}/${invoiceId}/datas`);
  };

  return (
    <Modal
      title="Nota fiscal"
      open={cfopModalVisible}
      onCancel={setCfopModalVisible}
      onOk={handleUpdadeCfop}
      okText="Transmitir nota"
    >
      <Form form={form}>
        <FloatingFormItem
          label="CFOP"
          name="cfopId"
          rules={[defaultEmptyFieldError]}
        >
          <CfopSelectField />
        </FloatingFormItem>
      </Form>
    </Modal>
  );
}
